import { Autopilot } from 'pageCores/autopilot'
import { inject, observer } from 'mobx-react'
import { getStaticFunctionsWithLocale } from 'utils/internationalization'

export const { getStaticPaths, getStaticProps } = getStaticFunctionsWithLocale('/autopilot')

const AutopilotController = ({ rootStore }) => {
	return <Autopilot rootStore={rootStore} />
}

export default inject('rootStore')(observer(AutopilotController))
